module.exports = __webpack_public_path__ + "static/img/add-image.246898c8.svg";